import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScratchCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconScratchCard"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11 8.5L6 10.2067L16.8 8.92667L6 12.34L16 11.4867L9.33333 14.0467L18 12.7667L9 15.4333L14 15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconScratchCard;
